import './App.css';
import TwitchEmbed from './components/twitchEmbed';

function App() {
  return (
    <div className="App">
      <TwitchEmbed channel={"cohhcarnage"}/>
    </div>
  );
}

export default App;
